/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: ZhangLei
 * @Date: 2020-08-12 13:56:13
 * @LastEditTime: 2020-08-12 13:56:52
 * @LastEditors: ZhangLei
 * @Description:
 * @FilePath: /desktop/src/service/userService.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import request from "@/utils/request";

export function getCaptchaApi(object) {
  /**
   * 获取图形码
   */
  return request({
    url: "/api/v1/auth/captcha",
    method: "GET"
  });
}

/**
 *获取token
 * @userName 用户信息
 */
export function getTokenApi(user) {
  return request({
    url: "/api/v1/auth/token",
    method: "POST",
    data: {
      clientId: user.userName,
      clientSecret: user.passWord,
      captcha: user.Captcha,
      sequence: user.timestamp,
      clientType: "Desktop"
    }
  });
}


/**
 * 获取权限
 */
export function getAuthorityApi() {
  return request({
    url: "/api/v1/menus",
    method: "GET",
    data: {}
  });
}

/**
 * 退出登录
 */
export function logout() {
  return request({
    url: "/api/v1/mine/logout",
    method: "POST",
    data: {}
  });
}

/**
 * 退出登录
 */
export function getSSOConfig() {
  return request({
    url: "/api/v1/sso/getConfig",
    method: "GET",
  });
}

/**
 * 用户信息
 */
export function getUserInfo() {
  return request({
    url: "/api/v1/mine",
    method: "GET"
  });
}
/**
 * 路由
 */
export function getUserMenu() {
  return request({
    url: "/api/v1/mine/menus",
    method: "GET"
  });
}
/**
 * 路由
 */
export function getConfig() {
  return request({
    url: "/api/v1/system/configuration-0x0823",
    method: "GET"
  });
}

/**
 * 用户列表
 */
export function getUsersData(Info) {
  return request({
    url:
      "/api/v1/users?size=" +
      Info.size +
      "&page=" +
      Info.page +
      "&filter=" +
      Info.filter +
      "&search=" +
      Info.search +
      "&order=" +
      Info.order,
    method: "GET"
  });
}
/*
 * 新建users页面数据
 */
export function createUsers(data) {
  return request({
    url: "/api/v1/users",
    method: "POST",
    data: data
  });
}

/*
 * 编辑users页面数据
 */
export function editUsers(data) {
  return request({
    url: "/api/v1/users/" + data.id,
    method: "PATCH",
    data: data.data
  });
}
/*
 * 获取User数据详情
 */
export function getUsersInfo(id) {
  return request({
    url: "/api/v1/users/" + id,
    method: "GET"
  });
}
/*
 * 删除user数据
 */
export function deleteUsers(id) {
  return request({
    url: "/api/v1/users/" + id,
    method: "DELETE"
  });
}



// WEBPACK FOOTER //
// ./src/service/userService.js